// extracted by mini-css-extract-plugin
export default {"zoomModal":"q4-z"};